import styled from "@emotion/styled";
import { TABLET_QUERY_MAX_WIDTH, MOBILE_QUERY_MAX_WIDTH_M, MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import { generateCloudinaryImageUrl } from "services/community/cloudinary-service";
import Colors from "styles/colors";
import { BRAND_BLACK_TEXT_COLOR, BRAND_WORK_MANAGEMENT_PRIMARY_COLOR, BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01, WHITE_COLOR_NAME } from "styles/color-consts";
import { careersCommonStyles } from "components/pages/careers/careers-common-style.scss";
import { slickStyle } from "components/pages/careers/slick.scss";
import { slickThemeStyle } from "components/pages/careers/slick-theme.scss";
import { bulmaStyles } from "components/pages/careers/bulma.scss";
const YELLOW = "#ffcb00";
const RED = "#fb275d";
const BLUE = "#595ad4";
const GREEN = "#00ca72";
export const StyledCareersComponent = styled.div`
  /* Monday.com color helpers: */

  ${bulmaStyles}

  .has-background-yellow {
    background: ${YELLOW};
  }

  .has-background-red {
    background: ${RED};
  }

  .has-background-green {
    background: ${GREEN};
  }

  .has-background-blue {
    background: ${BLUE};
  }

  /* removing header's drop shadow to fit design */

  .basic-header-content-wrapper.with-shadow {
    box-shadow: none;
  }

  .internal-careers-bottom-folds {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;

    .internal-title {
      margin-bottom: 50px;
      font-size: 3em;
    }

    @media (max-width: ${MOBILE_QUERY_MAX_WIDTH_M}) {
      .internal-title {
        font-size: 1.5em;
        margin-bottom: 0;
      }
    }

    .internal-careers-video {
      margin-bottom: 50px;
      margin-top: 30px;
    }
  }

  .section h3.title {
    font-weight: normal;
    font-size: 2.7rem;
    line-height: 70px;
    /* or 146% */
    letter-spacing: -0.991px;

    strong {
      font-weight: bold;
    }
  }

  .position-counts {
    height: 20px;
    font-size: 1rem;
    line-height: 100%;
    letter-spacing: -0.02em;
    color: #383b45;
    margin-bottom: 8px;
  }

  .section-search {
    padding: 0;
    position: sticky;
    top: 72px;
    z-index: 554;

    .search-filter-bar {
      font-weight: normal;
      font-size: 1rem;
      line-height: 40px;
      /* identical to box height, or 222% */
      letter-spacing: -0.3px;
      color: #666972;

      div.filters-container {
        display: flex;
        margin-left: 150px;

        legend {
          font-weight: 600;
          font-size: 1.125rem;
          line-height: 40px;
          /* identical to box height, or 200% */

          letter-spacing: -0.3px;
          color: #383b45;

          margin-right: 10px;
        }

        .dropdown {
          margin-left: 7px;
        }

        #dropdown-menu-teams {
          > .dropdown-content {
            max-height: calc(100vh - 72px - 94px);
            overflow: auto;
          }
        }

        #dropdown-menu-locations {
          width: 528px;

          > .dropdown-content {
            max-height: calc(100vh - 72px - 94px);
            overflow: auto;
          }

          a.dropdown-item:not(.dropdown-title) {
            margin: 0 auto;
            display: inline-block;
            width: 234px;
            min-width: unset;

            picture {
              position: absolute;
              left: 0;
              top: 0;
              text-align: center;
            }
          }
        }

        &.force-dropdowns-to-close .dropdown-content {
          display: none;
        }
      }
    }

    .search-selectors {
      font-weight: normal;
      background: white;
      padding: 25px 0;

      &::after {
        content: "";
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 8px;
        box-shadow: 0 4px 4px rgba(29, 140, 242, 0.08);
        z-index: 19;
      }

      .field {
        justify-content: center;
      }

      .input-search {
        input {
          width: 452px;
          height: 40px;

          padding-left: 48px;
          padding-bottom: 11px;
          box-sizing: border-box;

          border: 1px solid #c0cade;
          border-radius: 20px;
          background: #ffffff;

          font-size: 1rem;
          line-height: 18px;

          &::placeholder {
            color: #9699a6;
            font-family: "Poppins";
          }
        }

        .icon.search-icon {
          top: -1px;
          left: 8px;

          svg {
            height: 21px;

            path {
              fill: #9699a6;
            }
          }
        }

        .icon.clear-icon {
          top: 0px;
          right: 15px;
          width: 24px;

          cursor: pointer;
          pointer-events: unset;
        }
      }

      .blue-rnd-btn {
        font-size: 0.875rem;
        background: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
        color: white;
        width: 150px;
        height: 40px;
        box-shadow: 0px 3.45298px 6.90597px rgba(0, 0, 0, 0.101025);
        border-radius: 20px;
        font-weight: bold;
      }
    }
  }

  .loader-container {
    /* in desktop: inside section-position, in mobile: on all screen */
    position: absolute;
    top: 64px;
    left: -2px;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .section-positions {
    position: relative;
    padding-top: 1rem;
    padding-bottom: 150px;
    margin-top: 56px;

    @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
      margin-top: 0;
    }

    .no-search-results {
      margin-top: 50px;

      .title {
        font-weight: bold;
        font-size: 1.75rem;
        line-height: 38px;
        margin: 7px 0 27px 0;
      }

      p {
        font-size: 1rem;
        line-height: 28px;
        /* or 156% */
        color: #383b45;

        width: 440px;
        margin: 0 auto;

        a {
          color: #0085ff;
          text-decoration: underline;
        }
      }
    }

    table {
      width: 100%;
      display: table;

      caption {
        position: absolute;
        top: -58px;
        left: 0;

        text-align: left;
        font-weight: 300;
        font-size: 1rem;
        line-height: 40px;
        letter-spacing: -0.3px;
        color: #666972;
        margin-bottom: 14px;
      }

      td {
        padding: 0.5em 0em 0.5em 0;
        border-bottom-width: 2px;
        border-color: #e6e9ef;
        font-size: 1rem;
        line-height: 40px;
      }

      td.pos-name {
        /* tab focus is on TR - so we hide any click focus on TD */

        &:focus {
          outline: 0;
        }

        a {
          color: black;
          display: block;
          line-height: 120%;
          padding: 7px 0px;

          &:focus {
            outline: 0;
          }
        }

        .media-left {
          margin-right: 40px;
          margin-left: -20px;
          transform: scale(0.5);

          width: 72.5px;
          height: 49px;

          .team-pics-sprite {
            background-image: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite.png")});
            background-repeat: no-repeat;
            display: block;
            margin-top: -20px;

            &.team-pics-sprite-Consulting1 {
              width: 145px;
              height: 98px;
              background-position: -505px -486px;
            }

            &.team-pics-sprite-Consulting2 {
              width: 145px;
              height: 98px;
              background-position: -670px -10px;
            }

            &.team-pics-sprite-Consulting3 {
              width: 145px;
              height: 98px;
              background-position: -670px -128px;
            }

            &.team-pics-sprite-Consulting4 {
              width: 145px;
              height: 98px;
              background-position: -670px -246px;
            }

            &.team-pics-sprite-CS2 {
              width: 145px;
              height: 98px;
              background-position: -670px -364px;
            }

            &.team-pics-sprite-CS3 {
              width: 145px;
              height: 98px;
              background-position: -670px -482px;
            }

            &.team-pics-sprite-CS1 {
              width: 145px;
              height: 98px;
              background-position: -10px -605px;
            }

            &.team-pics-sprite-CS5 {
              width: 145px;
              height: 98px;
              background-position: -175px -605px;
            }

            &.team-pics-sprite-CS4 {
              width: 145px;
              height: 98px;
              background-position: -340px -605px;
            }

            &.team-pics-sprite-Design1 {
              width: 145px;
              height: 99px;
              background-position: -10px -10px;
            }

            &.team-pics-sprite-Design2 {
              width: 145px;
              height: 99px;
              background-position: -175px -10px;
            }

            &.team-pics-sprite-Design3 {
              width: 145px;
              height: 99px;
              background-position: -10px -129px;
            }

            &.team-pics-sprite-Design4 {
              width: 145px;
              height: 99px;
              background-position: -175px -129px;
            }

            &.team-pics-sprite-Design5 {
              width: 145px;
              height: 99px;
              background-position: -340px -10px;
            }

            &.team-pics-sprite-Finance1 {
              width: 145px;
              height: 99px;
              background-position: -340px -129px;
            }

            &.team-pics-sprite-Finance2 {
              width: 145px;
              height: 99px;
              background-position: -10px -248px;
            }

            &.team-pics-sprite-HR1 {
              width: 145px;
              height: 98px;
              background-position: -505px -605px;
            }

            &.team-pics-sprite-HR2 {
              width: 145px;
              height: 98px;
              background-position: -670px -605px;
            }

            &.team-pics-sprite-HR3 {
              width: 145px;
              height: 98px;
              background-position: -835px -10px;
            }

            &.team-pics-sprite-HR4 {
              width: 145px;
              height: 98px;
              background-position: -835px -128px;
            }

            &.team-pics-sprite-HR5 {
              width: 145px;
              height: 98px;
              background-position: -835px -246px;
            }

            &.team-pics-sprite-Marketing1 {
              width: 145px;
              height: 98px;
              background-position: -835px -364px;
            }

            &.team-pics-sprite-Marketing2 {
              width: 145px;
              height: 98px;
              background-position: -835px -482px;
            }

            &.team-pics-sprite-Marketing3 {
              width: 145px;
              height: 98px;
              background-position: -835px -600px;
            }

            &.team-pics-sprite-Operations2 {
              width: 145px;
              height: 99px;
              background-position: -175px -248px;
            }

            &.team-pics-sprite-Operations1 {
              width: 145px;
              height: 99px;
              background-position: -340px -248px;
            }

            &.team-pics-sprite-Operations3 {
              width: 145px;
              height: 99px;
              background-position: -10px -367px;
            }

            &.team-pics-sprite-Partnership1 {
              width: 145px;
              height: 99px;
              background-position: -175px -367px;
            }

            &.team-pics-sprite-Partnership2 {
              width: 145px;
              height: 99px;
              background-position: -340px -367px;
            }

            &.team-pics-sprite-Partnership3 {
              width: 145px;
              height: 99px;
              background-position: -505px -10px;
            }

            &.team-pics-sprite-Partnership4 {
              width: 145px;
              height: 99px;
              background-position: -505px -129px;
            }

            &.team-pics-sprite-Partnership5 {
              width: 145px;
              height: 99px;
              background-position: -505px -248px;
            }

            &.team-pics-sprite-Social_Impact1 {
              width: 145px;
              height: 99px;
              background-position: -175px -367px;
            }

            &.team-pics-sprite-Social_Impact2 {
              width: 145px;
              height: 99px;
              background-position: -340px -367px;
            }

            &.team-pics-sprite-Social_Impact3 {
              width: 145px;
              height: 99px;
              background-position: -505px -10px;
            }

            &.team-pics-sprite-Social_Impact4 {
              width: 145px;
              height: 99px;
              background-position: -505px -129px;
            }

            &.team-pics-sprite-Social_Impact5 {
              width: 145px;
              height: 99px;
              background-position: -505px -248px;
            }

            &.team-pics-sprite-Product1 {
              width: 145px;
              height: 98px;
              background-position: -10px -723px;
            }

            &.team-pics-sprite-Product2 {
              width: 145px;
              height: 98px;
              background-position: -175px -723px;
            }

            &.team-pics-sprite-Product3 {
              width: 145px;
              height: 98px;
              background-position: -340px -723px;
            }

            &.team-pics-sprite-R_D1 {
              width: 145px;
              height: 99px;
              background-position: -505px -367px;
            }

            &.team-pics-sprite-R_D2 {
              width: 145px;
              height: 99px;
              background-position: -10px -486px;
            }

            &.team-pics-sprite-R_D3 {
              width: 145px;
              height: 99px;
              background-position: -175px -486px;
            }

            &.team-pics-sprite-R_D4 {
              width: 145px;
              height: 99px;
              background-position: -340px -486px;
            }

            &.team-pics-sprite-SFS1 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -10px;
            }

            &.team-pics-sprite-SFS2 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -129px;
            }

            &.team-pics-sprite-SFS3 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -248px;
            }

            &.team-pics-sprite-SFS4 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -367px;
            }

            &.team-pics-sprite-SFS5 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -486px;
            }

            &.team-pics-sprite-Communications4 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -605px;
            }

            &.team-pics-sprite-Communications5 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -724px;
            }

            &.team-pics-sprite-Communications1 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -843px;
            }

            &.team-pics-sprite-Communications2 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -962px;
            }

            &.team-pics-sprite-Communications3 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite2.png")}) -10px -1081px;
            }

            &.team-pics-sprite-Legal1 {
              width: 145px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_legal.png")}) -5px -5px;
            }

            &.team-pics-sprite-Legal2 {
              width: 144px;
              height: 98px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_legal.png")}) -5px -114px;
            }

            &.team-pics-sprite-Legal3 {
              width: 144px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_legal.png")}) -5px -222px;
            }

            &.team-pics-sprite-RevenueOperations1 {
              width: 144px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite.png")}) -670px -723px;
            }

            &.team-pics-sprite-RevenueOperations2 {
              width: 144px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite.png")}) -835px -723px;
            }

            &.team-pics-sprite-Programs1 {
              width: 144px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite.png")}) -505px -723px;
            }

            &.team-pics-sprite-Programs2 {
              width: 144px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite.png")}) -670px -723px;
            }

            &.team-pics-sprite-Programs3 {
              width: 144px;
              height: 99px;
              background: url(${generateCloudinaryImageUrl("/static/img/careers/team_pics_sprite.png")}) -835px -723px;
            }
          }
        }

        .position-name {
          display: block;

          font-style: normal;
          font-weight: bold;
          font-size: 1.125rem;
          line-height: 26px;
          margin: 0px 0 1px 0;
          /* identical to box height, or 200% */

          letter-spacing: -0.3px;
        }

        small {
          font-size: 0.6875rem;
          line-height: 18px;
          margin-top: 4px;
          display: table-caption;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          /* default width works for "DESKTOP WIDE" bulma width */
          width: 645px;

          /* "DESKTOP" width */
          @media (min-width: 1025px) and (max-width: 1215px) {
            width: 600px;
          }

          /* "TABLET" width */
          @media (min-width: 769px) and (max-width: 1024px) {
            width: 400px;
          }
        }
      }

      .iconwithlabel {
        display: table-cell;
        vertical-align: middle;
        color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};

        min-width: 160px;

        &.pos-dept {
        }

        > span {
          span {
            margin-right: 10px;
            width: 30px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
          }
        }
      }
    }

    .pagination {
      a {
        border: 0;
        font-weight: bold;
        font-size: 0.6875rem;
        line-height: 12px;
        text-align: center;
        color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};

        &:active {
          box-shadow: none;
        }

        &.is-current {
          background: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
          border-radius: 2px;
          font-weight: bold;
          font-size: 0.875rem;
          line-height: 16px;
          text-align: center;
          color: #ffffff;
        }

        &.directional-progress-link {
          svg {
            path {
              fill: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
            }
          }

          &.link-prev {
            svg {
              transform: rotate(180deg);
            }
          }

          &.is-disabled {
            cursor: pointer;
            pointer-events: none;

            svg {
              path {
                fill: #c5c7d0;
              }
            }
          }
        }
      }
    }

    .iconwithlabel {
      display: table-cell;
      vertical-align: middle;
      color: #009aff;

      min-width: 160px;

      &.pos-dept {
      }

      > span {
        span {
          margin-right: 10px;
          width: 30px;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
        }
      }
    }

    .show-more-less-container {
      margin-top: 70px;

      a {
        color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
        font-weight: bold;
      }

      .show-more-less {
        font-size: 0.875rem;

        svg {
          display: inline-block;
          margin-left: 7px;
          fill: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
        }

        &.show-less svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  .section-best-work-place-mobile {
    display: none !important;
  }

  .section-testimonials {
    position: relative;

    .title {
      color: #fb275d;
      margin-bottom: 45px;
    }

    .quote-container {
      position: relative;

      .quote-icon {
        position: absolute;
        top: 30px;
        left: 48px;
        width: 63px;
      }

      .quote-inner {
        font-weight: bold;
        font-size: 1.125rem;
        line-height: 32px;
        /* or 160% */

        letter-spacing: -0.486474px;

        padding: 45px 127px 70px 127px;

        width: 87%;
        background: #f2f3f4;

        blockquote {
          font-weight: normal;
          font-size: 1.125rem;
          line-height: 32px;
          letter-spacing: -0.486474px;
          color: #383b45;
          max-width: 720px;

          margin-bottom: 64px;
        }

        .quotee-name {
          font-weight: bold;
        }

        .quotee-dept {
          font-weight: bold;
        }

        .quotee-title {
          font-weight: normal;
          color: #2d2d2d;
        }

        .quotee-img {
          position: absolute;
          right: 0px;
          top: 0px;
          width: 277px;
          height: 270px;

          .quotee-img-container {
            position: relative;
          }

          img {
            position: absolute;
            top: 52px;
            left: 0;
            height: 165px;
            width: auto;
          }
        }
      }
    }
  }

  .section-tiles {
    margin-top: 100px;

    .title {
      color: #595ad4;
      margin-bottom: 62px;
    }

    .tile {
      /* is-child = bulma displayed tile container (not parent or ancestor) */

      &.is-child {
        color: white;

        /*  > img { */

        .tile-img {
          width: 100%;
          height: 101%; /*101% fixed an 1px white border issue*/
          margin: 0 !important;
          object-fit: cover;
          display: block;
        }

        /* hover-effect causes the animation on hover with an overlay mask (not the texts switching) */

        &.hover-effect {
          position: relative;

          &:after {
            content: "";
            width: 100%;
            height: 100%;
            position: absolute;

            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            opacity: 0;
            background: #323338;
            z-index: 200;
            -webkit-transition: 0.3s ease-in-out;
            transition: 0.3s ease-in-out;
          }

          &:hover:after,
          &:focus:after {
            opacity: 0.15;
          }
        }

        .tile-content.back {
          display: none;
          position: relative;
        }

        &:hover,
        &:focus {
          .tile-content.front {
            display: none;
          }

          .tile-content.back {
            display: block;
          }
        }

        //tile-content = "our" content holder (switched w/animation)
        .tile-content {
          z-index: 500;

          &.has-brand-value {
            /* 1nd text style - "value" (e.g. "Transparency") - title */
            font-weight: bold;
            font-size: 2.025rem;

            display: flex;
            height: 100%;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          }

          /* 2nd text style - text paragraph */

          &.has-text {
            font-size: 1rem;
            line-height: 30px;
            letter-spacing: -0.486474px;
            padding: 31px;
          }

          .is-rotated-text {
            font-weight: bold;
            font-size: 2.025rem;
            transform: rotate(-90deg);
          }
        }
      }
    }

    /* gapless support for bulma tiles. adapted from : https://codepen.io/hus_hmd/pen/xzBGGo*/

    .tile.is-gapless {
      .tile.is-parent {
        padding: 0;
      }

      .tile.is-vertical > .tile.is-child {
        margin-bottom: 0 !important;
      }

      .notification {
        border-radius: 0;
      }
    }
  }

  .section-news {
    margin-top: 68px;

    .title {
      margin-bottom: 82px;
    }

    .container {
      max-width: 1042px;
    }

    .card {
      height: 100%;

      .card-image {
        img {
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
        }
      }

      .card-content {
        margin-bottom: 30px;

        .card-footer {
          position: absolute;
          bottom: 10px;
          border-top: unset;
        }
      }
    }
  }

  .section-equality {
    .diversity-paragraph {
      background-color: #eeeeff;
      border-radius: 10px;
      padding-right: 15%;
      padding-left: 15%;
      padding-top: 40px;
      padding-bottom: 40px;
      text-align: center;
      margin-right: 10%;
      margin-left: 10%;
      margin-bottom: 40px;
      line-height: 26px;
      font-size: 1rem;
    }
  }

  .section-footer {
    text-align: center;
    margin-bottom: 140px;
  }

  // custom pill-style bulma dropdown
  .dropdown.is-pill {
    margin-top: 4px;
    color: #323338;

    &:hover .dropdown-trigger .button,
    &.is-active .dropdown-trigger .button,
    .dropdown-trigger.has-selection .button {
      box-shadow: none;
      background: ${Colors[BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01]};
      border: 1px solid;
      border-color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
      color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
    }

    &:hover .dropdown-trigger button,
    &.is-active .dropdown-trigger button {
      .icon {
        svg {
          transform: rotate(180deg);
        }
      }
    }

    .dropdown-trigger {
      button {
        background: ${Colors[WHITE_COLOR_NAME]};
        border-radius: 20px;
        font-weight: normal;
        font-size: 0.8125rem;

        letter-spacing: -0.02em;

        color: #383b45;
        border: 1px solid ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
        border-color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};

        .icon svg {
          width: 8px;
        }

        /* image for location selection */

        .is-flex img {
          max-height: 19px;
          margin-right: 10px;
        }
      }
    }

    .dropdown-content {
      background: #ffffff;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
      border-radius: 8px;

      padding: 27px;

      .dropdown-title {
        font-weight: normal;
        font-size: 1.125rem;
        line-height: 22px;
        color: #1c1f3b;

        padding: 0;
        margin-bottom: 17px;
      }

      .dropdown-item:not(.dropdown-title) {
        /* slightly overridden at #dropdown-menu-locations */
        padding: 15px 17px 13px 15px;
        min-width: 270px;
        margin: 10px auto;

        font-size: 0.875rem;
        line-height: 22px;

        article {
          .media-left {
            width: 27px;
            text-align: center;
          }

          .media-content {
            line-height: 140%;

            strong {
              display: block;
              font-weight: bold;
              font-size: 1.125rem;
              margin-bottom: 11px;
              line-height: 100%;
            }
          }
        }
      }
    }

    /* columns item variation */

    &.is-columns-variation {
      .dropdown-content {
        width: 600px;
        padding: 27px 13px;
      }

      &.is-narrow {
        .dropdown-content {
          width: 300px;
        }

        .column.is-half {
          min-width: 270px;
        }
      }

      .columns {
        .dropdown-item:not(.dropdown-title) {
          min-width: 270px;
          padding: 7px 17px 7px 9px;

          article {
            .media-left {
              width: unset;
              margin-right: 14px;
            }

            .colored-ribbon {
              display: inline-block;
              width: 7px;
              height: 64px;
              margin-top: 7px;
              border-top-left-radius: 2px;
              border-bottom-left-radius: 2px;
            }

            p {
              white-space: break-spaces;
            }
          }
        }
      }
    }

    .dropdown-item:not(.dropdown-title):hover,
    .is-active.dropdown-item:not(.dropdown-title) {
      color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
      background-color: ${Colors[BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01]};
      border-radius: 5px;

      article .media-left {
        img {
          filter: invert(34%) sepia(93%) saturate(1037%) hue-rotate(218deg) brightness(98%) contrast(108%);
        }

        .colored-ribbon {
          background: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]} !important;
        }
      }
    }
  }

  ${slickThemeStyle}
  ${slickStyle}
  
  /* slick slider - margin between slides: */
  .slick-slide > div {
    padding: 0 25px;
  }

  /* the parent */

  .slick-list {
    margin: 0 -25px;
  }

  .slick-arrow {
    z-index: 10;
    cursor: pointer;
    width: 24px;
    height: 24px;

    background: url(${generateCloudinaryImageUrl("/static/img/careers/arrow-right.png")}) no-repeat;
    right: -50px;
    background-size: 24px 24px;
    top: 43%;
  }

  .slick-arrow.slick-prev {
    background-image: url(${generateCloudinaryImageUrl("/static/img/careers/arrow-left.png")});
    right: unset;
    left: -50px;
  }

  /* MOBILE DESIGN */
  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .section-mobile-search-container {
      position: sticky;
      top: 70px;
      background: white;
      z-index: 10;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    }

    .section-mobile-search {
      padding: 20px 0 10px 0;
      user-select: none;

      .has-mobile-search-width {
        padding-left: 1rem;
        padding-right: 1rem;
      }

      .mobile-search-input-wrapper {
        margin-bottom: 0;

        .input-search {
          width: 100%;

          .input {
            height: 47px;
            background: #f5f6f8;
            padding-left: 20px;
            border: none;
            border-top-left-radius: 200px;
            border-bottom-left-radius: 200px;

            font-weight: normal;
            font-size: 1rem;
            line-height: 18px;

            color: #666972;
          }

          .icon {
            /* "mag glass" icon: */

            svg {
              margin-top: 4px;
            }
          }
        }

        .pulldown-trigger-wrapper {
          background: #f5f6f8;
          border: none;
          width: 40px;
          margin-left: 4px;
          border-top-right-radius: 200px;
          border-bottom-right-radius: 200px;

          .pulldown-trigger {
            .filter-on {
              display: none;
            }

            .circ {
              position: absolute;
              top: -4px;
              right: 7px;
            }

            /* "filter" on/off icons */

            svg {
              margin-top: 13px;
              margin-left: 5px;
            }
          }

          &.has-active-selection {
            .pulldown-trigger {
              .filter-on {
                display: block;
              }

              .filter-off {
                display: none;
              }
            }
          }
        }
      }
    }

    .position-counts {
      font-size: 0.875rem;
      line-height: 300%;

      text-align: center;
      letter-spacing: -0.105px;

      height: unset;
      margin: 3px 0 0px 0;

      color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};

      strong {
        color: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
      }
    }

    .section h3.title {
      font-weight: normal;
      font-size: 1.75rem;
      line-height: 32px;
      letter-spacing: -0.02em;
    }

    #mobile-search-sidemenu {
      position: fixed;
      top: 0;
      right: calc(-100vw);
      width: 100%;
      height: 100%;

      /* on top of header */
      z-index: 10000;

      background: rgba(50, 51, 56, 0.25);

      /* display: none; */
      transition: right 0.2s ease;

      &.is-active {
        right: 0;
      }

      /* layout:  */

      .relative-container {
        position: relative;
        height: 100%;
        padding: 58px 0 18px;

        .close-btn-container {
          position: absolute;
          top: 0;
          left: 0;
          width: 60px;
          height: 100px;
          background: #676879;
          padding: 58px 0 18px;
          text-align: center;
        }

        .submenu-container {
          position: absolute;
          left: 60px;
          top: 0;
          bottom: 0;
          right: 0;
          background: #f6f6f6;

          .sub-menu {
            display: none;

            &.is-active {
              display: block;
            }

            .title-row {
              padding: 44px 12px 18px 16px;
              margin-bottom: 16px;
              background: white;
              height: 100px;

              .back-btn {
                position: absolute;
                top: 59px;
                left: 16px;
              }

              .subtitle {
                font-weight: bold;
                font-size: 1.375rem;
                line-height: 52px;
                letter-spacing: -0.02em;
                color: #333333;

                &.is-left-padded {
                  padding-left: 40px;
                }
              }

              .clear-btn {
                position: absolute;
                right: 16px;
                top: 60px;

                font-size: 0.875rem;
                line-height: 24px;
                color: #676879;
              }
            }

            .menu-container {
              /* enables scroll */
              position: absolute;
              top: 110px;
              bottom: 0;
              left: 0;
              right: 0;
              overflow: auto;

              .done-btn-container {
                background: #f6f6f6;
                position: sticky;
                bottom: 0;
                padding: 24px 8px 16px 8px;

                .done-btn {
                  background: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
                  width: 100%;
                  border-radius: 4px;
                  font-size: 1.375rem;
                  line-height: 24px;
                  text-align: center;
                  letter-spacing: -0.02em;
                  color: #ffffff;

                  filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.15));
                }
              }
            }
          }

          .menu-row {
            position: relative;
            padding: 27px 16px;
            height: 80px;
            margin-bottom: 4px;
            background: white;

            letter-spacing: -0.110769px;
            color: #333333;

            font-size: 1rem;
            line-height: 18px;

            &.team-item {
              padding-left: 0;

              position: relative;

              .colored-ribbon {
                position: absolute;
                width: 8px;
                left: 0;
                top: 0;
                bottom: 0;
              }
            }

            article {
              .media-left {
                width: 32px;
                text-align: center;
              }

              .media-content {
                font-size: 0.875rem;
                line-height: 24px;
                color: #323338;

                .content {
                  width: calc(100vw - 164px);
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                strong {
                  font-weight: normal;
                  font-size: 1.125rem;
                  line-height: 24px;
                  margin-right: 13px;
                }
              }
            }

            &.location-item {
              .media-left {
                display: flex;
                justify-content: center;

                .image {
                  margin-top: 1px;

                  img {
                    height: auto;
                    width: auto;
                  }

                  &.slightly-upper {
                    margin-top: -4px;
                  }
                }
              }
            }

            /* active menu row */

            &.is-active {
              color: #009aff;
              background: #dff0ff;

              border-radius: 5px;

              &:after {
                content: url(${generateCloudinaryImageUrl("/static/img/careers/check.png")});
                position: absolute;
                right: 10px;
                top: 28px;
              }

              article {
                .media-content {
                  color: #009aff;

                  strong {
                    color: #009aff;
                  }
                }

                .media-left {
                  img {
                    filter: invert(63%) sepia(100%) saturate(4690%) hue-rotate(181deg) brightness(100%) contrast(107%);
                  }
                }
              }
            }
          }
        }
      }
    }

    .loader-container {
      position: fixed;
      top: 0;
      z-index: 100;
    }

    .section-positions {
      position: unset;
      padding: 0px 0 12px 0;

      .no-search-results {
        margin-top: 20px;

        img {
          height: 140px;
        }

        .title {
          font-size: 1.125rem;
          line-height: 24px;
          letter-spacing: -0.3px;
        }

        p {
          font-size: 0.8125rem;
          line-height: 22px;
          letter-spacing: -0.02em;
          max-width: 95%;
        }
      }

      .mobile-results {
        > .result {
          padding-left: 1rem;
          padding-right: 1rem;
          padding-bottom: 1rem;
          padding-top: 1.1rem;

          font-weight: normal;
          font-size: 0.6875rem;
          line-height: 24px;
          letter-spacing: -0.3px;

          color: #383b45;
          background: white;
          border-bottom: 6px solid #f0f0f0;

          &:last-child {
            border-bottom: none;
          }

          a,
          a:hover {
            color: #383b45;
          }

          .position-name {
            font-weight: bold;
            font-size: 1rem;
            line-height: 28px;
            letter-spacing: -0.3px;
            margin-bottom: 5px;
          }

          small {
            display: table-caption;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            width: calc(100vw - 50px);

            margin-top: 4px;

            font-weight: normal;
            font-size: 0.875rem;
            line-height: 24px;
            letter-spacing: -0.3px;
            color: #383b45;
          }

          .bottom-row {
            margin-top: 10px;

            .colored-pill {
              /* used for location or team colored pill in mobile's results */
              height: 34px;
              display: inline-block;
              padding: 7.5px 16px 8px 16px;
              background: #dff0ff;
              color: #ffffff;

              border-radius: 16px;
              font-size: 0.875rem;
              line-height: 16px;

              &.location-pill {
                margin-left: 10px;
                color: #0085ff;
              }
            }
          }
        }
      }

      .show-more-less-container {
        margin-top: 45px;
      }
    }

    .section-best-work-place-mobile {
      display: block !important;
      padding: 0 24px;

      .title-and-proof {
        text-align: center;
      }

      .picture-component {
        display: flex;
        justify-content: center;
      }
    }

    .section-testimonials {
      margin-top: 0;

      .slick-arrow {
        display: none !important;
      }

      .slick-dots {
        bottom: -100px;

        li.slick-active button {
          background-color: #c0cade !important;
        }
      }

      .quote-container {
        .quote-icon {
          z-index: -1;
          width: 90px;
          top: 0;
          left: 0;

          path {
            fill: #f2f3f4;
          }
        }

        .quote-inner {
          padding: 0;
          width: 100%;
          background: none;
          font-size: 0.875rem;
          line-height: 24px;
          letter-spacing: -0.486474px;

          blockquote {
            min-height: 220px;
            padding-top: 33px;
            font-weight: normal;
            font-size: 0.875rem;
            line-height: 24px;
            letter-spacing: -0.486474px;
            margin-bottom: 30px;
            max-width: unset;
          }

          .quotee-details {
            font-size: 0.6875rem;
            line-height: 20px;
            letter-spacing: -0.486474px;

            padding-bottom: 30px;
            padding-left: 95px;

            .quotee-name {
              display: inline;
            }

            .quotee-title {
              display: inline;

              .pipe {
                display: inline;
              }
            }
          }

          .quotee-name {
          }

          .quotee-img {
            position: absolute;
            left: 0px;
            top: unset;
            right: unset;
            bottom: 0px;
            width: 80px;
            height: auto;

            img {
              width: 80px;
              border-radius: 3px;

              position: unset;
              top: unset;
              left: unset;

              height: unset;
            }
          }
        }
      }
    }

    .section-tiles {
      .values-slider {
        .value-slide {
          /* height: 328px; */
          height: 87vw;
          position: relative;

          .value-title {
            text-align: center;
            height: 50%;
            font-weight: bold;
            font-size: 1.75rem;
            line-height: 32px;
            /* identical to box height */

            display: flex;
            align-items: center;
            justify-content: center;

            /* 01 Fill/White */

            color: #ffffff;
          }

          &.has-background-yellow .value-title {
            color: #323338;
          }

          .value-image {
            position: absolute;
            top: 50%;
            height: 50%;
            left: 0;
            width: 100%;
            object-fit: cover;
          }

          .value-image.full-height {
            top: 0;
            height: 100%;
          }
        }
      }

      .slick-dots {
        bottom: -50px;
      }
    }

    .section-news {
      .container {
        margin-top: 10px;
        margin-bottom: 0px;

        .columns .column {
          padding-bottom: 0px;
        }

        .title {
          margin-bottom: 40px;
        }

        /* makes the card-news shorter (on mobile, only in careers-page) */

        .card-news {
          position: relative;
          min-height: 160px;

          @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
            min-height: 110px;
          }

          .card-image {
            position: absolute;
            top: 15px;
            left: 15px;

            img {
              width: 75px;
              height: 75px;
              border-radius: 16px;
              object-fit: cover;
              object-position: 5% 5%;
            }
          }

          .card-content {
            padding: 10px 10px 10px 100px;

            > p {
              font-weight: bold;
              font-size: 0.875rem;
              line-height: 20px;
              letter-spacing: -0.3px;

              color: #383b45;

              margin-bottom: 0px;
            }

            .card-footer {
              bottom: 10px;
              border-top: none;
              font-weight: normal;
              font-size: 0.8125rem;
              line-height: 22px;
              letter-spacing: -0.105px;

              margin-top: 5px;
              color: ${Colors.asphalt};
            }
          }
        }
      }
    }

    .section-equality {
      .diversity-paragraph {
        margin-right: 5%;
        margin-left: 5%;
        padding-right: 5%;
        padding-left: 5%;
        font-size: 0.875rem;
        line-height: 24px;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .section-best-work-place-mobile {
      .title-and-proof {
        text-align: left !important;
      }
    }
  }

  /* DESKTOP RESPONSIVE FIXES */
  @media screen and (max-width: 1408px) {
    .section-tiles {
      .tile {
        &.is-child {
          .tile-content {
            &.has-text {
              padding: 25px !important; /* on desktop */
            }
          }
        }
      }
    }
  }

  ${careersCommonStyles}
`;
